/**
 * Client-side event kind for UI badges / palettes.
 * Prefer an explicit `type` when present; otherwise infer from title/details.
 * Proto does not yet expose a dedicated kind field — document in PR / issue #183.
 */
export type EventKind = "storytime" | "diy";

export type EventKindInput = {
  type?: string | null;
  title?: string | null;
  details?: string | null;
};

const STORYTIME_RE =
  /story\s*time|storytime|bilingual story|绘本|read(?:ing)? aloud/i;
const DIY_RE =
  /\bdiy\b|craft|workshop|makers?\b|coding|code\b|tech\b|stem\b|moms who code|build your|web app/i;

export function resolveEventKind(input: EventKindInput): EventKind {
  const explicit = (input.type || "").toLowerCase().trim();
  if (explicit === "storytime") return "storytime";
  if (
    explicit === "tech" ||
    explicit === "diy" ||
    explicit === "workshop" ||
    explicit === "craft"
  ) {
    return "diy";
  }

  const text = `${input.title || ""} ${input.details || ""}`;
  const hasDiy = DIY_RE.test(text);
  const hasStory = STORYTIME_RE.test(text);

  if (hasDiy && !hasStory) return "diy";
  if (hasStory && !hasDiy) return "storytime";
  if (hasDiy) return "diy";
  if (hasStory) return "storytime";
  return "storytime";
}

export function eventKindLabel(kind: EventKind): string {
  return kind === "diy" ? "DIY" : "Storytime";
}
